const RESIZE_METHODS = {
    FILL: 'fill',
    FIT: 'fit',
    FULL: 'full',
    VIDEO: 'video',
};
export default RESIZE_METHODS;
//# sourceMappingURL=resizeMethods.js.map